export class Attachment {
    id: number;

    // These are used for our files
    AssignmentId: number;
	AttachmentAddedBy: string;
	AttachmentAddedOn = new Date();
	AttachmentDescription: string;
	AttachmentFileBase: string;
	AttachmentFileMimeType: string;
	AttachmentFileName: string;
    AttachmentId: number;
    AttachmentNotes: string;
    AttachmentNotesSpanish: string; // NOTE: currently only provided by OR, but the record contains the data
    AttachmentNotesFrench: string;  // NOTE: currently only provided by OR, but the record contains the data
    AttachmentRequired: boolean;
    DocumentId: number;
    DocumentBase64: string;
    DocumentFileId: number;
	DocumentMimeType: string;
	DocumentName: string;
	DocumentType: string;
	DocumentTypeId: number;
    Id: number;

    // Local Properties
	Deleted = false;

    // These are used for uploads universally
    MyFile: any; // This is a user's file upload
    MyFileName: string;
    MyFileBase64String: string; // This is the user's file upload as a string
    OriginalFileName: string;   // This is the file name before the user applies a new name for our end
    Base64String: string;

    // These are used for a parent's file
    FileDescription: string; // The description of the user's file
    FileExtension: string; // The file's type
    FileName: string; // The file's name
    MemberId: number; // This is the user who the attachment pertains to
    UploadedDate = new Date(); // This is the date the user uploaded the file
    UploadedBy: string // This is the user who uploaded the file
    CreateDate: string;

    // These are used for a teacher's file (don't ask why...)
    FileType: string; // The file's type
    PortalCommunicationId: number; // I have no idea
    Description: string;    // The file's description

    // Used for Communication Log files
    Comment: string;
    ViewFileOnWebsite: boolean;
    CommunicationLogId: number;
    MassEmailAttachment: boolean;
}
